import React,{ useState,useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ModalCloseIcon from "../../assets/svg/close-modal.svg";

import len from '../../assets/svg/lentra.svg'

import "./gate-out-modal.css";
import userTemp from '../../assets/png/customer-icon.png'
import { getVisitorDetailsApi,  } from "../visitor/visitor-api";
import { getVehicleDetailsApi } from "../vehicle/vehicle-api";
import { updateAcknowledgement } from "./setup-api";


 const AcknowledgementModal = ({moduleName, visitorDetails,onSuccess, onCancel, }) => {
   
   const [visitorData, setVisitorData] = useState({});
   const [acknowledgeDetails, setAcknowledgeDetails] = useState('');
   const [acknowledgeError, setAcknowledgeError] = useState(''); 

   useEffect(() => {
    setVisitorData(visitorDetails)
    if(moduleName==="Visitor"){
      getVisitorDetails();
    }
    if(moduleName==="Vehicle"){
      getVehicleDetails();
    }
  }, [visitorDetails]); 
    const modalStyle = {
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          opacity: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        },
        modal: {
          backgroundColor: "#ffffff",
          
          borderRadius: "16px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          width: "468px",
          /* height:"500px", */
          overflowY: "auto",
        },
      };


  const getVisitorDetails = async () => {
    try {
      const response = await getVisitorDetailsApi(visitorDetails.id);
      if (response.status === true) {
        setVisitorData(response.visitor ?? {})
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
    const getVehicleDetails = async () => {
                 try {
                   const response = await getVehicleDetailsApi(visitorDetails.id);
                   if (response.status === true) {
                     setVisitorData(response.vehicle ?? {})
                   }
                   return response.data;
                 } catch (err) {
                   console.error("Error fetching category:", err);
                 } finally {
                 }
               };
        const acknowledgeUpdate = async () => {
                       if(acknowledgeDetails!=""){

                       }else{
                        setAcknowledgeError("Acknowledgement required!")
                       } 
                        const payload = {
                         "comment": acknowledgeDetails,
                         };
                         try {
                           const response = await updateAcknowledgement(visitorDetails.id,payload);
                           if (response.statusCode === 400) {}
                           else{
                                 if(response.data.status===true){                           
                                   onSuccess(response.data)
                                 }else{
                                        
                                       }
                           }
                       return response.data;
                         } catch (err) {
                           console.error("Error fetching category:", err);
                         } finally {
                         }
                       };
         
         
            
    return ( <div style={modalStyle.overlay}>
     
        <div style={modalStyle.modal}>
          
          <div >
            <div className="modal-header style-justify-between"
            >
              <div className="modal-title"
    >
    Acknowledgement
    </div>
    <img
                              src={ModalCloseIcon}
                              alt="Close"
                              onClick={onCancel}
                              style={{ cursor: "pointer",width: "30px", height: "30px", borderRadius: "50%" }}
                            />
      
            </div>

             <div style={{ display: "flex", gap: "8px" }}>
                        {/* Left Section */}
                        <div
                          style={{
                            width: "100%",
                            background: "#fff",
                            borderRadius: "12px",
                            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                            padding: "15px",
                           
                          }}
                        >
                          {/* Profile */}
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <img
                              src={visitorData.profilephoto!=="" && visitorData.profilephoto?visitorData.profilephoto:userTemp}
                              alt="Profile"
                              style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                            />
                            <div>
                              <div className="visitor-name">
                              {visitorData.visitor_name??''} {visitorData.driver_name??''}
                              </div>
                              {moduleName==="Visitor" && (<div><img src={len} alt=""/> <span className="org-title">{visitorData.organization}</span>
                              </div>)}
                              {moduleName==="Vehicle" && (<div style={{ display: "flex", alignItems: "center",}}>
                  <div className="field-title pt-1">{visitorData.vehicle_number}</div> <span className="dot-span mx-2"></span> <div className="vehicle-type-card px-2 pt-1">{visitorData.vehicle_type}</div>
                </div>)}
                            </div>
                          </div>
              
                          {/* Info Badges */}
                          <div style={{ display: "flex", gap: "10px", marginTop: "12px" }}>
                            <div className="in-time-card px-2 py-1"                            >
                              <span className="in-time-title">In time</span>
                              <div className="font-13-600">
                              {visitorData.in_time??''}
                              </div>
                            </div>
                            {moduleName==="Visitor" && (<div
                              className="in-time-card  px-2 py-1" 
                            >
                              <span className="in-time-title">Purpose of visit</span>
                              <div className="font-13-600">
                              {visitorData.visit_purpose??''} 
                              </div>
                            </div>)}
                          </div>
              
                          {/* Details */}
                          <div className="mt-3"
                           
                          >
                            <div className="font-15-700 ">Acknowledgement</div>
                                              
                      <textarea
                        type="text"
                        placeholder=" "
                        className="input-field w-100"
                        value={acknowledgeDetails}
                        onChange={(event) => {
                          setAcknowledgeDetails(event.target.value); // Update state with input value
                        }}
                      />
                       <span className="field-error">{acknowledgeError}</span>
                   


                          </div>
                         
                        </div>
                        
              
                        
                       
                      </div>
                      <div className="mt-3 mb-2"                
            >
              <div className="style-justify-end me-3">
              <div
                onClick={onCancel} className="admin-checklist-cancel-btn style-justify-center"                  
              >
               Cancel
              </div>

             <div
                 onClick={()=>{acknowledgeUpdate()}}  className="schedule-approve-btn style-justify-center px-5"                  
              >
               Submit
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>);

}

export default AcknowledgementModal;